import type * as turf from "@turf/turf";
export const isValidGeoJSON = (geoJSONString: string): boolean => {
  try {
    const geoJSONObject = JSON.parse(geoJSONString);

    //   flyToPolygon(statefulMap, geoJSONObject, { duration: 1000 });

    // Additional validation logic can be placed here
    return true;
  } catch (e) {
    return false;
  }
};
export function getZoomLevel(
  [minLng, minLat, maxLng, maxLat]: ReturnType<typeof turf.bbox>,
  mapWidthPx = 512,
  mapHeightPx = 512,
  paddingPx = 0,
): number {
  const WORLD_DIM = { height: 256, width: 256 };
  const ZOOM_MAX = 22;

  function latRad(lat: number) {
    const sin = Math.sin((lat * Math.PI) / 180);
    return Math.log((1 + sin) / (1 - sin)) / 2;
  }

  function zoom(mapPx: number, worldPx: number, fraction: number) {
    return Math.log2(mapPx / worldPx / fraction);
  }

  const latFraction = (latRad(maxLat) - latRad(minLat)) / Math.PI;
  const lngDiff = maxLng - minLng;
  const lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

  const latZoom = zoom(
    mapHeightPx - 2 * paddingPx,
    WORLD_DIM.height,
    latFraction,
  );
  const lngZoom = zoom(
    mapWidthPx - 2 * paddingPx,
    WORLD_DIM.width,
    lngFraction,
  );

  return Math.min(latZoom, lngZoom, ZOOM_MAX);
}
